import { EFonts } from 'libs/styles/styling';
import React from 'react';
import styled, { css } from 'styled-components/macro';

interface MarkerProps {
    text: string;
    category1: 'true' | 'false';
    category2: 'true' | 'false';
    category3: 'true' | 'false';
    category4: 'true' | 'false';
    category5: 'true' | 'false';
    category6: 'true' | 'false';
    isHighlighted: 'true' | 'false';
}

// 1. Økonomi, regnskap og revisjon
// 2. Markedsførign
// 3. Rettsvitenskap
// 4. Samfunnsvitenskap
// 5. Informasjonsteknologi
// 6. Andre studieretninger

export const markerUIAVariables = [
    {
        variableName: 'text' as const,
        type: 'string' as const
    },
    {
        variableName: 'isHighlighted' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category1' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category2' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category3' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category4' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category5' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category6' as const,
        type: 'boolean' as const
    }
];

export const markerUIA = (props: MarkerProps) => {
    const isInCategory1 = props.category1 === 'true';
    const isInCategory2 = props.category2 === 'true';
    const isInCategory3 = props.category3 === 'true';
    const isInCategory4 = props.category4 === 'true';
    const isInCategory5 = props.category5 === 'true';
    const isInCategory6 = props.category6 === 'true';

    const isHighlighted = props.isHighlighted === 'true';

    const isInAnyCategory =
        isInCategory1 ||
        isInCategory2 ||
        isInCategory3 ||
        isInCategory4 ||
        isInCategory5 ||
        isInCategory6;

    return (
        <S_Container $isHighlighted={isHighlighted}>
            <S_Text>{props.text}</S_Text>
            {isInAnyCategory && (
                <S_Circle $isHighlighted={isHighlighted}>
                    <S_InnerCircle $isHighlighted={isHighlighted}>
                        {isInCategory1 && (
                            <S_Triangle
                                $background={'#A876E3'}
                                // $background={'linear-gradient(180deg, #A876E3 0%, #5D2F94 100%)'}
                                $rotate={210}
                            />
                        )}
                        {isInCategory2 && (
                            <S_Triangle
                                $background={'#FAE465'}
                                // $background={'linear-gradient(180deg, #FAE465 0%, #A79112 100%)'}
                                $rotate={270}
                            />
                        )}
                        {isInCategory3 && (
                            <S_Triangle
                                $background={'#97C87F'}
                                // $background={'linear-gradient(180deg, #97C87F 0%, #477131 100%)'}
                                $rotate={330}
                            />
                        )}
                        {isInCategory4 && (
                            <S_Triangle
                                $background={'#7A9AE1'}
                                // $background={'linear-gradient(180deg, #7A9AE1 0%, #183982 100%)'}
                                $rotate={30}
                            />
                        )}
                        {isInCategory5 && (
                            <S_Triangle
                                $background={'#CFA027'}
                                // $background={'linear-gradient(180deg, #D9694F 0%, #912C14 100%)'}
                                $rotate={90}
                            />
                        )}
                        {isInCategory6 && (
                            <S_Triangle
                                // $background={'linear-gradient(180deg, #CFA027 0%, #E2A54D 0.01%, #AD6E12 100%)'}
                                $background={'#D9694F'}
                                $rotate={150}
                            />
                        )}

                        <S_Line $rotate={210} />
                        <S_Line $rotate={270} />
                        <S_Line $rotate={330} />
                        <S_Line $rotate={30} />
                        <S_Line $rotate={90} />
                        <S_Line $rotate={150} />
                    </S_InnerCircle>
                </S_Circle>
            )}
        </S_Container>
    );
};

interface SContainerProps {
    $isHighlighted: boolean;
}

const S_Container = styled.div.attrs<SContainerProps>((props) => ({
    style: {
        background: props.$isHighlighted ? 'rgb(255 244 227)' : '#CCF1F9'
    }
}))<SContainerProps>`
    width: 125px;
    height: 70px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #193143;
    ${(props) => {
        if (props.$isHighlighted) {
            return css`
                box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.15), inset 0px -3px 0px #c89e78,
                    inset 0px 0px 30px 5px #cdb187;
            `;
        } else {
            return css`
                box-shadow: 2px 2px 10px rgb(0 0 0 / 15%), inset 0px -3px 0px #70b6c4,
                    inset 0px 0px 20px 5px #70b9c8;
            `;
        }
    }}
`;

const S_Text = styled.div`
    font-family: ${EFonts.Regular};
    font-size: 15.5px;
    padding: 0 3px;
    margin: -3px 0 0 0;
`;

interface S_Circle {
    $isHighlighted: boolean;
}

const S_Circle = styled.div.attrs<S_Circle>((props) => ({
    style: {
        background: props.$isHighlighted ? '#D6BD9A' : ' #C6E7EE'
    }
}))<S_Circle>`
    width: 36px;
    height: 36px;
    display: block;
    position: absolute;
    bottom: -18px;
    left: 44.5px;
    border-radius: 50%;
    padding: 1px;
    border: 1px solid #113042;
`;

interface SInnerCircleProps {
    $isHighlighted: boolean;
}

const S_InnerCircle = styled.div.attrs<SInnerCircleProps>((props) => ({
    style: {
        background: props.$isHighlighted ? '#D6BD9A' : ' #C6E7EE'
    }
}))<SInnerCircleProps>`
    width: 30px;
    height: 30px;
    display: block;
    margin: 1px 0px 0px 1px;
    border-radius: 50%;
    border: 1px solid #113042;
    overflow: hidden;
    position: relative;
`;

interface STriangleProps {
    $rotate: number;
    $background: string;
}

const S_Triangle = styled.div.attrs<STriangleProps>((props) => ({
    style: {
        background: props.$background,
        transform: `rotate(${props.$rotate}deg)`
    }
}))<STriangleProps>`
    clip-path: polygon(50% 0, 100% 100%, 0 100%);
    width: 20px;
    height: 17px;
    padding: 1px;
    bottom: 0;
    position: absolute;
    left: 4px;
    top: 14px;
    transform-origin: top;
`;

interface SLineProps {
    $rotate: number;
}

const S_Line = styled.div.attrs<SLineProps>((props) => ({
    style: {
        transform: `rotate(${props.$rotate}deg)`
    }
}))<SLineProps>`
    transform-origin: center;
    left: -2px;
    right: -2px;
    top: 14px;
    position: absolute;
    height: 1px;
    background: #113042;
`;
